import React from "react";
import { Modal } from "react-bootstrap";
import ExperienceForm from "../ExperienceForm/ExperienceForm";

const AddExperienceModal = ({ show, handleClose, addExperience, title }) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="py-5 py-sm-10 py-md-15 py-lg-20 px-8 px-sm-15 px-md-25 px-lg-35">
        <Modal.Title className="ah-heading-06 fw-semibold">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-8 pt-sm-15 pt-md-25 pt-lg-32 pb-16 px-10 px-sm-20 px-md-30 px-lg-45">
        <ExperienceForm
          addExperience={addExperience}
          handleClose={handleClose}
        />
      </Modal.Body>
    </Modal>
  );
};

export default AddExperienceModal;